import React from 'react';
import './OtherIdentityPrompt.css';

/**
 * OtherIdentityPrompt Component
 * 
 * Displays an inline prompt when user selects "Other" identity category
 * Encourages immediate category request submission but allows skipping
 */
function OtherIdentityPrompt({ onRequestCategory, onSkip }) {
  return (
    <div className="other-identity-prompt">
      <div className="prompt-icon">💡</div>
      <div className="prompt-content">
        <h4>Don't see your identity category?</h4>
        <p>
          Request a new category now so we can add it to the platform. 
          You'll be notified when it's reviewed. You can also skip and request later from your profile.
        </p>
        <div className="prompt-actions">
          <button 
            type="button"
            className="btn-request-category"
            onClick={onRequestCategory}
          >
            📝 Request New Category
          </button>
          <button 
            type="button"
            className="btn-skip"
            onClick={onSkip}
          >
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default OtherIdentityPrompt;
